import { HelpersService } from '../../services/tools/helpers.service';
import { ValidatorService } from '../../services/tools/validator.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { SuccessModalComponent } from './../../components/tools/modals/success-modal/success-modal.component';
import { ErrorModalComponent } from './../../components/tools/modals/error-modal/error-modal.component';
import { ConfirmModalComponent } from './../../components/tools/modals/confirm-modal/confirm-modal.component';
import { Globals } from '../../services/tools/Globals.service';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { SucursalesService } from "./../../services/sucursales.service";
import { AutenticacionService } from './../../services/autenticacion.service';
import { SucursalesModalComponent } from './sucursales-modal/sucursales-modal.component';

@Component({
  selector: 'app-sucursales',
  templateUrl: './sucursales.component.html',
  styleUrls: ['./sucursales.component.scss']
})
export class SucursalesComponent implements OnInit {
  @ViewChild(SuccessModalComponent) successModal: SuccessModalComponent;
  @ViewChild(ErrorModalComponent) errorModal: ErrorModalComponent;
  @ViewChild(ConfirmModalComponent) confirmModal: ConfirmModalComponent;
  @ViewChild(SucursalesModalComponent) sucursalesModal: SucursalesModalComponent;

  object:any[];
  searchText:string = "";
  selected:any;
  mostrarListado:boolean = true;
  errors:any = {};
  searchProcess:any;
  paginate:any = {};
  filterBy:any;
  currentPage = 1;
  lastPage = 1;
  processing:any = false;
  alterTable:any = 'starting';
  sucursalesOptions : any = [];
  sucursalesSearchOptions: any[];
  searchSelected: any = {};

  page: number = 1;
  pageSize: number = 10;
  pageAll: number = 100;

  constructor(
    private validatorService: ValidatorService, 
    private helperService: HelpersService, 
    private Service: SucursalesService,
    private globals: Globals, 
    private config: NgbDropdownConfig,
    private authService: AutenticacionService,
    private router: Router){
      //Validate user has permission to use this view
      this.checkUserPermission();

      // se colocó esto para que el this dentro de delete sea el del scope global
      this.get();
      this.resetSelected = this.resetSelected.bind(this);
      this.delete = this.delete.bind(this);
      config.placement = 'bottom-right';
  }

  private checkUserPermission(){
    if(!this.authService.isAdmin()){
      this.router.navigate(['/']);
    }
  }

  ngOnInit() {
    this.globals.passwordActivate = false;
  }

  pageChanged(event: any): void {
    if(event.page !== undefined)
      if(event.page != this.page)
      {  
        this.page = event.page;
      }
    this.goPage(this.page);
  }
  
  filtrar(){
    this.goPage(1);
  }

  changesearchSelected(selected) {
    this.searchSelected = selected;
    this.search();
  }

  create(){
    this.sucursalesModal.open(null);
  }

  update(){
    this.sucursalesModal.open(this.selected);
  }

  resetSelected(){
    this.selected = undefined;
    this.errors = {};
  }

  startSelected(){
    this.resetSelected();
    this.selected = this.Service.getDefaultSchedule();
  }

  select(sucursal){
    this.resetSelected();
    const Cloned = JSON.parse(JSON.stringify( sucursal ));
    this.selected = Cloned;
  }

  SelectedClass(sucursal) {
    return (this.validatorService.required(this.selected) &&  this.selected.idInversionistas == sucursal.id)?"active":"";
  }

  confirmDelete() {
    this.confirmModal.open({
      'color': 'danger',
      'title': 'Eliminar sucursal',
      'description': "¡ATENCIÓN! <br> Está a punto de eliminar el sucursal.",
      'callback': this.delete
    });
  }

  delete(){
    this.processing = true;
    this.Service.delete(this.selected.id)
        .subscribe(
            response => {
              const deleted = JSON.parse(JSON.stringify( this.selected ));
              this.processing = false;
              this.successModal.open({
                'title': 'Sucursal eliminada',
                'description': 'La sucursal con datos: <br> Nombre: ' + deleted.nombre + '<br> Ha sido eliminada.'
              });

              this.goPage(this.currentPage);
              this.resetSelected();
            }, error => {
              this.processing = false;

              // se resuelve error 403 y 500
              this.helperService.httpGlobalError(error);

              if(error.status == 400) {
                this.setBackendErrors(error.json().content);
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
              }
            });
  }

  search(page = null){
    if (this.searchProcess){
      this.searchProcess.unsubscribe();
    }

    if (this.searchText.length > 1 || this.searchSelected.id != ''){
      if(this.searchSelected.id === undefined)
        this.searchSelected.id = '';
      this.searchProcess = this.Service.search(this.searchText, page)
          .subscribe(
            response => {
            const content = response.json().content;
            this.object = content.data;
            this.startPaginate(content);
            this.searchProcess = false;
            this.alterTable = (this.object.length > 0)? false: 'not_found';
          }, error => {
            this.processing = false;

            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status == 400) {
              this.setBackendErrors(error.json().content);
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
          });
    } else {
      this.get();
    }
  }

  get(page = null){

    this.searchProcess = this.Service.get(page)
      .subscribe(response => {
        const content = response.json().content;
        this.object = content.data;
        this.startPaginate(content);
        this.alterTable = (this.object.length > 0)? false: 'not_result';
      }, error => {
        // se resuelven los errores 403 y 500
        this.helperService.httpGlobalError(error, false);
      });
  }

  setBackendErrors(errors:any[]){
    let temp_errors = [];
    
    Object.keys(errors).forEach(function(key){
      temp_errors[key] = errors[key][0];
    });

    this.errors = temp_errors;
  }

  selectedWithId(){
    if(! this.selected)
      return false;

    return (this.validatorService.required(this.selected.id));
  }

  cancelarSelected() {
    this.confirmModal.open({
      'title': 'Cancelar Cambios',
      'description': '¿Está seguro que desea cancelar estos cambios?',
      'callback': this.resetSelected
    });
  }

  writePermission() {
    return this.Service.writePermission();
  }

  // MODAL FUNCTIONS
  modalCallback(callback){
    callback();
  }

  // MAIN SECTIONS FUNCTIONS 
  mainContainerClass(){
    return (this.mostrarListado)?"col-12":"offset-2 col-8";
  }

  mainTableClass(){
    return (this.mostrarListado)?"col-8":"col-4";
  }

  mainDetailsClass(){
    return (this.mostrarListado)?"col-4":"col-8";
  }

  startPaginate(content){
    this.paginate.first_item = content.from;
    this.paginate.last_item = content.to;
    this.paginate.last_page = content.last_page;
    this.paginate.per_page = content.per_page;
    this.paginate.total_items = content.total;
    this.paginate.current_page = content.current_page;
    this.currentPage = content.current_page;
    this.lastPage = content.last_page;

    this.paginate.pages = [];
    for(let i = 1; i <= this.paginate.last_page; i++){
      this.paginate.pages.push({
        'number': i,
        'label': i
      });
    }
    this.pageAll = content.total;
    this.pageSize = content.per_page;
  }

  goPreviousPage(){
    this.goPage(this.paginate.current_page - 1)
  }

  goNextPage(){
    this.goPage(this.paginate.current_page + 1);
  }

  goPage(page) {

    if (this.searchText) {
      this.search(page);
    } else {
      this.get(page);
    }

  }

  changeSwitchListado(){
    if(!this.mostrarListado){
      this.selected = this.Service.getDefaultSchedule();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/administracion/sucursales/sucursales.component.ts